import { useMediaQuery } from '../useMediaQuery/useMediaQuery';

const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Reads whether the user has requested reduced motion via their system preferences.
 * Should not be used in the render phase of React components.
 */
function getPrefersReducedMotion() {
  return window.matchMedia(PREFERS_REDUCED_MOTION_QUERY).matches;
}

/**
 * Custom hook that returns whether the user has requested reduced motion via their system preferences.
 * Should be used if needed in the render phase of React components.
 */
function usePrefersReducedMotion() {
  return useMediaQuery(PREFERS_REDUCED_MOTION_QUERY, { defaultMatches: false });
}

/**
 * Returns the appropriate scroll behavior based on the user's reduced motion preference.
 * Should not be used in the render phase of React components.
 * @param [prefersReducedMotion]
 */
function getScrollBehavior(prefersReducedMotion = getPrefersReducedMotion()): ScrollBehavior {
  return prefersReducedMotion ? 'instant' : 'smooth';
}

/**
 * Custom hook that returns the appropriate scroll behavior based on the user's reduced motion preference.
 * Should be used if needed in the render phase of React components.
 */
function useScrollBehavior() {
  const prefersReducedMotion = usePrefersReducedMotion();
  return getScrollBehavior(prefersReducedMotion);
}

export { getPrefersReducedMotion, getScrollBehavior, usePrefersReducedMotion, useScrollBehavior };
